import { Add, Edit } from '@mui/icons-material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Autocomplete, Box, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import Emptyfile1 from "../assets/svg/Emptyfile1.svg";
import { newHost } from '../pages/Categories/CategoryProfile';
const MaintenanceVanProfile = () => {
    const { user } = useSelector((state) => state.auth);
    const token = "Bearer " + user?.token;

    
      
        const {id : vanId} = useParams()
        const [show, setShow] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [vehicleMaintenance, setVehicleMaintenance ] = useState([])
        const [vehicleInspection, setVehicleInspection ] = useState([])
        const [maintenanceTypes, setMaintenanceTypes ] = useState([])
        const [maintenanceStatus, setMaintenanceStatus] = useState([])
        const [maintenanceId, setMaintenanceId ] = useState(null)
        const [page, setPage] = useState(0); 

        const [total, setTotal] = useState(); 

                
                 const {control, register, handleSubmit, setValue, reset} = useForm()
                
                 const handleClose = () => {
                    setShow(false)
                    setIsEdit(false)
                    reset({
                      status:"",
                      inspection_id:"",
                      type:"",
                      completed_date:null,
                      scheduled_date:null,
                      issues_found:"",
                      performed_by:"",
                      actions_taken:"",
                      cost: ""
                    })
                  }
                  const handleShow = () => {
                    setShow(true)
                  };

  const [openRows, setOpenRows] = useState([]);

  const handleToggleRow = (id) => {
    setOpenRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };



      const getVehicleMaintenance = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/vehicles/${vanId}/maintenance?page=${page + 1}`,{
            headers:  { Authorization: token}
          })
          console.log(response.data.data?.maintenance_history?.data);
          const resData = response.data.data?.maintenance_history;

          setVehicleMaintenance(response.data.data?.maintenance_history?.data)
                setTotal(resData.total || 0);

        } catch (error) {
          console.log(error);
          
        }
      }          
      const getVehicleInspection = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/vehicles/${vanId}/inspections`,{
            headers:  { Authorization: token}
          })
          console.log(response.data.data);
          
          setVehicleInspection(response.data.data?.inspections)
        } catch (error) {
          console.log(error);
          
        }
      }          
      const getMaintenanceTypes = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/maintenance/types`,{
            headers:  { Authorization: token}
          })
          console.log(response.data.data);
          
          setMaintenanceTypes(response.data.data?.details)
        } catch (error) {
          console.log(error);
          
        }
      }          
      const getMaintenanceStatus = async ()=>{
        try {
          const response = await axios.get(`${newHost}portal/maintenance/statuses`,{
            headers:  { Authorization: token}
          })
          console.log(response.data.data);
          
          setMaintenanceStatus(response.data.data?.details)
        } catch (error) {
          console.log(error);
          
        }
      }          
      const submitMaintenance = async (data)=>{
        console.log(data);
        if(isEdit){
                try {
          const response = await axios.post(`${newHost}portal/vehicles/${vanId}/maintenance/${maintenanceId}`,{
            ...data,
            _method: "PUT"
          },{
            headers:  { Authorization: token}
          })
          toast.success(response.data.message)
          getVehicleMaintenance()
          handleClose()
          reset()
        } catch (error) {
          console.log(error);
          toast.error(error.response.data.message)
        }
        }
        else{
            try {
          const response = await axios.post(`${newHost}portal/vehicles/${vanId}/maintenance`,data,{
            headers:  { Authorization: token}
          })
          toast.success(response.data.message)
          getVehicleMaintenance()
          handleClose()
          reset()
        } catch (error) {
          console.log(error);
          toast.error(error.response.data.message)
        }
        }

      }        
      const handleUpdateMaintenance =  (maintenance,e)=>{
        console.log(maintenance);
        e.stopPropagation()
        setShow(true)
        setMaintenanceId(maintenance.id)
        setIsEdit(true)

        setValue("inspection_id", maintenance.inspection_id)
        setValue("performed_by", maintenance.performed_by)
        setValue("scheduled_date",maintenance.scheduled_date? dayjs(maintenance.scheduled_date) : null)
        setValue("completed_date", maintenance.completed_date? dayjs(maintenance.completed_date) : null)
        setValue("type", maintenance.type) 
        setValue("issues_found", maintenance.issues_found) 
        setValue("actions_taken", maintenance.actions_taken) 
        setValue("cost", maintenance.cost) 
        setValue("status", maintenance.status) 


      }  
      const handleChangePage = (event, newPage) => {
    setPage(newPage);
        console.log(newPage);

  };


    useEffect(() => {
     getVehicleInspection()
     getMaintenanceTypes()
     getMaintenanceStatus()
    }, [])
      useEffect(() => {
    if (vanId) getVehicleMaintenance();
  }, [vanId, page]);
    
            
            
  return (
<>
     <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-size-md">
                        <Modal.Header style={{ backgroundColor: "#D5D5D5" }}>
                          <Modal.Title className="text-black">Add Maintenance</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{}}>
                          <form onSubmit={handleSubmit(submitMaintenance)} action="" >
                            <div className="row ">
                                <div className="col-12 col-lg-4">
                                     <div className="">
                              <label htmlFor="">Inspection ID</label>
                            <Controller
                                    name="inspection_id"
                                    control={control}
                                  render={({ field }) => {
                const options = vehicleInspection.map(option => ({
                  label: option.type?.name,
                  id: option.id,
                }));

                return (
                  <Autocomplete
                    size="small"
                    options={options}
                    value={options.find(opt => opt.id == field.value) || null}

                    onChange={(e, item) => {
                      field.onChange(item ? item.id : null);
                    }}

                    renderOption={(props, option) => (
                      <li {...props} className="p-2">
                        {option.label}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Inspection ID" />
                    )}
                  />
                );
              }}
                                  />
                            </div>
                                </div>
                                <div className="col-12 col-lg-4">
                                     <div className="">
                              <label htmlFor="">Performed by</label>
                              <TextField
                              size='small'
                                style={{ outlineColor: "black", }}
                                className='w-100 mt-1 ' type='text' placeholder='Enter Name'
                                {...register("performed_by")}
                              />
                            </div>
                                </div>
                                  <div className="col-12 col-lg-4">
                                 <div className="">
                          <label className='mt-1' htmlFor="">Scheduled Date</label>
        
                        <div className="date-remove-space">
        
                         <LocalizationProvider  dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            
                            
                            components={["DatePicker"]} 
                            
                          >
                                  <Controller
                                    name="scheduled_date"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                      <DatePicker
                                      slotProps={{ textField: { size: 'small' } }}

                                        {...field}
                                        value={field.value}
                                        onChange={(date) => field.onChange(date)}
                                        
                                      />
                                    )}
                                  />
                          </DemoContainer>
                        </LocalizationProvider>
                       </div>
                                 </div>
                                </div>
                             
                                </div> 
                            <div className="row">
                               <div className="col-12 col-lg-4">
                                 <div className="">
                          <label className='mt-1' htmlFor="">Completed Date</label>
        
                        <div className="date-remove-space">
        
                         <LocalizationProvider  dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            
                            
                            components={["DatePicker"]} 
                            
                          >
                                  <Controller
                                    name="completed_date"
                                    control={control}
                                    render={({ field, fieldState }) => (
                                      <DatePicker
                                        slotProps={{ textField: { size: 'small' } }}

                                        {...field}
                                        value={field.value}
                                        onChange={(date) => field.onChange(date)}
                                        
                                      />
                                    )}
                                  />
                          </DemoContainer>
                        </LocalizationProvider>
                       </div>
                                 </div>
                                </div>
                              
                              
                         <div className="col-12 col-lg-4">
                                     <div className="">
                              <label htmlFor="">Type</label>
                            <Controller
                                    name="type"
                                    control={control}
                                  render={({ field }) => {
                const options = maintenanceTypes.map(option => ({
                  label: option.label,
                  id: option.value,
                }));

                return (
                  <Autocomplete
                    size="small"
                    options={options}
                    value={options.find(opt => opt.id == field.value) || null}

                    onChange={(e, item) => {
                      field.onChange(item ? item.id : null);
                    }}

                    renderOption={(props, option) => (
                      <li {...props} className="p-2">
                        {option.label}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Type" />
                    )}
                  />
                );
              }}
                                  />
                                </div>
                                </div>
                                  <div className="col-12 col-lg-4">
                                 <div className="">
                                  <label htmlFor="">Status</label>
                                  <Controller
                                    name="status"
                                    control={control}
                                render={({ field }) => {
                const options = maintenanceStatus.map(option => ({
                  label: option.label,
                  id: option.value,
                }));

                return (
                  <Autocomplete
                    size="small"
                    options={options}
                    value={options.find(opt => opt.id == field.value) || null}

                    onChange={(e, item) => {
                      field.onChange(item ? item.id : null);
                    }}

                    renderOption={(props, option) => (
                      <li {...props} className="p-2">
                        {option.label}
                      </li>
                    )}

                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Status" />
                    )}
                  />
                );
              }}
                                  />
                
                                 
                                </div>
                                </div>
                                </div> 
    <div className="row">
            <div className="col-12 col-lg-4">
                                           <div className="">
                              <label htmlFor="">Maintenance Cost</label>
                              <TextField
                              size='small'
                                style={{ outlineColor: "black", }}
                                className='w-100 mt-1 ' type='number' placeholder='Enter Cost 00.00 EGP'
                                {...register("cost")}
                              />
                            </div>
                                </div>
    </div>
                                 <div className="my-2">
                                    <label htmlFor="">Issue Found</label>
                                    <textarea {...register("issues_found")} style={{padding:10, borderRadius:15,border:"solid 2px #D8D8D8",}}  rows={3} className='w-100 my-1'  type='text' placeholder='Add Issue Found' 
        
                                    />
                                </div>
                             
                                 <div className="my-2">
                                    <label htmlFor="">Action Taken</label>
                                    <textarea {...register("actions_taken")} style={{padding:10, borderRadius:15,border:"solid 2px #D8D8D8",}}  rows={3} className='w-100 my-1'  type='text' placeholder='Add Action Taken' 
        
                                    />
                                </div>
                             
                 
                
                            
                            
                            <div className="d-flex gap-3 justify-content-center align-items-center custom-card-sm my-3">
                              <button className="btn btn-dark px-5">Save</button>
                              <button type="reset" onClick={handleClose} className="btn btn-light px-5">Cancel</button>
                            </div>
                          </form>
                        </Modal.Body>
                      </Modal>
     <div className="col-md-12 min-vh-100">
        <div className="">
          <div
            className=" p-3 my-3 col-md-12 rounded-2 min-vh-100 "
            style={{ border: "2px solid #EAEAEA " }}
          >
                <div className="d-flex justify-content-between align-items-center">
            <h6 className='m-0 fw-semibold'>
              Maintenance History
            </h6>
            <button onClick={handleShow} className='btn btn-light mx-1'>
                <Add/>
                New Maintenance Record</button>
        </div>
    {vehicleMaintenance.length > 0 ?
     <>
       <TableContainer
      component={Paper}
      sx={{
        mt: 2,
        boxShadow: "none", 
        border: "1px solid #ddd",
        borderRadius: "8px",
        width:"100%"
      }}
    >
      <Table
        size="small"
        sx={{
          borderCollapse: "collapse", 
          "& td, & th": {
            textAlign: "center", 
            verticalAlign: "middle",
          },
          "td":{
            p:"14px"
          }
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Inspection ID</TableCell>
            <TableCell>Performed By</TableCell>
            <TableCell>Scheduled Date</TableCell>
            <TableCell>Completed Date</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Cost</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {vehicleMaintenance?.map((row) => {
            const isOpen = openRows.includes(row.id);
            return (
              <React.Fragment key={row.id}>
                <TableRow
                  
                
                >
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.inspection_id}</TableCell>
                  <TableCell>{row.performed_by}</TableCell>
                  <TableCell>
                    {row.scheduled_date
                      ? new Date(row.scheduled_date).toLocaleDateString()
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {row.completed_date
                      ? new Date(row.completed_date).toLocaleDateString()
                      : "-"}
                  </TableCell>
                  <TableCell>{row.type}</TableCell>
                  <TableCell>
                    
                       <div className={`${row.status == "completed"? "completed-status-color": row.status == "scheduled"? "scheduled-status-color" : row.status == "in_progress"? "inprogress-status-color": "cancelled-status-color"}`}>{row.status}</div>
                    </TableCell>
                  <TableCell sx={{fontWeight:"bold"}}>{`${row.cost} EGP`}</TableCell>

                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={(e) => handleUpdateMaintenance(row, e)}
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleToggleRow(row.id)}
                    >
                      <ArrowDropDownIcon
                        sx={{
                          transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "0.3s",
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell
                    style={{
                      padding: 0,
                      borderTop: "none",
                    }}
                    colSpan={9}
                  >
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <Box
                        sx={{
                          p: 2,
                          textAlign: "left",
                          backgroundColor: "#F8F8F8",
                          borderTop: "1px solid #ddd",
                        }}
                      >
                        
                        <Typography variant="body2" className='d-flex align-items-center gap-1 m-0'>
                          <Typography sx={{color:"#535353"}} className='m-0'>Issue Found:</Typography> {row.issues_found? row.issues_found : "-"}
                        </Typography>
                        <Typography variant="body2" className='d-flex align-items-center gap-1 m-0'>
                          <Typography sx={{color:"#535353"}} className='m-0'>Action Taken:</Typography> {row.actions_taken? row.actions_taken : "-"}
                        </Typography>
                    
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
        <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={10} 
        rowsPerPageOptions={[]} 
        sx={{
          ".MuiTablePagination-toolbar": { justifyContent: "center" },
        }}
      />
    
    </>
    :
    <div className=" d-flex  flex-column  align-items-center justify-content-center vh-100 ">
                  <div className=" text-center ">
                    <div>
                      <img
                        src={Emptyfile1}
                        className="img-fluid "
                        alt="No Staff"
                      />
                    </div>
                    <div className="lh-lg StaffStyle ">
                      <div>No Maintenance History added yet. Start by <br /> recording the last service check.</div>
                      
                    </div>
                  </div>
                </div>
    
    }
  
          </div>
    
        </div>

    </div>

</>
  )
}

export default MaintenanceVanProfile